/* eslint-disable import/prefer-default-export */
import processing_activities_messages from 'messages/processing_activities_messages';

type Translate = (message: string | string[]) => string;

const retentionUnitMessages = processing_activities_messages.editor.retention_units as Record<string, string[]>;

export const formatRetentionPeriodAndUnit = (retentionValue: number | null | undefined, retentionUnit: string, t: Translate): string => {
  const unitMessage = retentionUnit ? retentionUnitMessages[retentionUnit] : undefined;
  const unitLabel = unitMessage ? t(unitMessage) : retentionUnit.trim();

  if (retentionValue != null && unitLabel) {
    return `${retentionValue} ${unitLabel}`;
  }

  if (retentionValue != null) {
    return String(retentionValue);
  }

  return unitLabel;
};
